import type { PortalTypeKey } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'

export type GestorSolicitacaoCard = {
  key: PortalTypeKey
  title: string
  description: string
  slaHours: number
  emoji: string
}

/** Chamados pré-definidos para gestores de setor. */
export const GESTOR_SOLICITACOES: GestorSolicitacaoCard[] = [
  {
    key: 'G5_CONTRATACAO_PJ',
    title: 'Contratação',
    description:
      'Solicite a entrada de um novo profissional PJ no setor. Informe dados do candidato, função, remuneração prevista e alinhamento da liderança focal.',
    slaHours: 24,
    emoji: '🤝',
  },
  {
    key: 'G1_ENTRADA_CONTRATO',
    title: 'Solicitação de viagem de negócios',
    description:
      'Solicite e programe seus encargos com antecedência! Informe destino, datas e motivo da viagem.',
    slaHours: 24,
    emoji: '✈️',
  },
  {
    key: 'G2_ATUALIZACAO',
    title: 'Encerramento de contrato de prestação de serviço PJ',
    description:
      'Formalize o encerramento de contrato com profissional parceiro. Um protocolo será gerado para resolver pendências. SLA mínimo de 10 horas.',
    slaHours: 10,
    emoji: '📄',
  },
  {
    key: 'P7_SERVICOS_CLIENTE',
    title: 'Reembolso',
    description:
      'Solicite reembolso de despesas do setor. Anexe comprovantes e descreva a finalidade do gasto.',
    slaHours: 16,
    emoji: '💳',
  },
  {
    key: 'G3_2_VIA',
    title: 'Solicitação de acesso',
    description:
      'Precisa de ajuda com novos acessos ou está sem acesso a um sistema? Vamos resolver! Prazo de SLA de 6h.',
    slaHours: 6,
    emoji: '🔐',
  },
]

export const GESTOR_FERIAS_RULES = [
  'Ter 12 meses de parceria',
  '12 notas fiscais emitidas',
  'Período aprovado pela liderança focal do departamento',
  'Os 20 dias devem ser fracionados',
]
